import {PropsWithChildren, useMemo} from 'react'
import {createPortal} from 'react-dom'
type ModalProps = {
  open?: boolean
  onCancel?(e: any): void
  width?: number | string
  height?: number | string
  align?: string
}
export default function Modal(props: PropsWithChildren<ModalProps>) {
  if (!props.open) return null
  const width = useMemo(() => {
    return props.width || '80%'
  }, [])
  const height = useMemo(() => {
    return props.height || 500
  }, [])
  const top = useMemo(() => {
    const adminbar = document.querySelector('#wpadminbar')
    if (adminbar) {
      return 0
    }
    return 0
  }, [])
  return createPortal(
    <div className={'fixed'} style={{ zIndex: 999999 }}>
      <div className={'fixed inset-0 z-10 w-screen overflow-y-auto'} style={{ top }}>
        <div className={'fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity'} onClick={props.onCancel}></div>
        <div className={'flex h-full items-center text-center sm:items-center'}
             style={{ justifyContent: props.align || 'center' }}
        >
          <div
            className={'relative transform overflow-auto bg-white text-left shadow-xl transition-all sm:my-8'}
            style={{ width, height }}
          >
            <div className={'absolute w-6 h-6 right-4 top-4 lg:w-8 lg:h-8 lg:right-8 lg:top-8 z-10 text-gray-400 '} onClick={props.onCancel}>
              <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.4906 0L33 30.5093L30.5094 32.9998L3.61095e-05 2.49055L2.4906 0Z" fill="currentColor"/>
                <path d="M33 2.49072L2.49056 33L0 30.5094L30.5094 0.000163752L33 2.49072Z" fill="currentColor"/>
              </svg>
            </div>
            {props.children}
          </div>
        </div>
      </div>
    </div>,
    document.body
  )

}